import { createContext } from 'react';

import { Task } from '@bringg/types';

type ExternalDeps = {
	isAllowedToAssignSpecificTask: (task: Task) => boolean;
};

const ExternalDepsContext = createContext<ExternalDeps>({
	isAllowedToAssignSpecificTask: () => false
});

export default ExternalDepsContext;
